define(['angular', '../module', './toolbarOptions.provider'], function(angular, MODULE_NAME, UiToolbarOptions) {
    'use strict';

    var templateUrl = require('../views/toolbar.template.html');
    angular.module(MODULE_NAME)
        .directive('ilmnUiToolbar', UiToolbarDirective);

    function UiToolbarDirective() {
        return {
            restrict: 'EA',
            controller: UiToolbarController,
            controllerAs: 'vm',
            templateUrl: templateUrl,
            bindToController: true,
            scope: {
                options: '='
            }
        }
    }

    UiToolbarController.$inject = [UiToolbarOptions];
    function UiToolbarController(UiToolbarOptions) {
        var vm = this;

        if(vm.options && !(vm.options instanceof UiToolbarController)) {
            vm.options = new UiToolbarOptions(vm.options.options || []);
        }

        vm.optionClicked = function(option) {
            if(option.action) {
                option.action.call(option);
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-toolbar/scripts/toolbar.directive.js
// module id = 13
// module chunks = 0